

























































































import {Component, Prop, Vue} from "vue-property-decorator";

import {eGameStage} from "@/common/enumData";

@Component({
    components: {},
})
export default class SelectStage extends Vue {
    @Prop() projectInfo !: any;
    uploadStage = eGameStage;

    selectedStage:number = 0;

    mounted() {
        this.$store.commit("gameStage", null);
    }

    selectStage(selectedStage: number) {
        if (this.projectInfo) {
            const {projectVersions, stage} = this.projectInfo;

            if (selectedStage === eGameStage.Dev) {
                if (projectVersions.length > 0) {
                    this.$modal.show('changedStage')
                    this.selectedStage = selectedStage;
                }
                else {
                    this.saveStage(selectedStage);
                }
            }
            else {
                this.saveStage(selectedStage);

            }
        }else{
            this.saveStage(selectedStage);
        }

    }

    changedStage() {
        this.saveStage(this.selectedStage);
        this.$modal.hide('changedStage')
    }

    saveStage(stage:number){
        this.$emit('stage', stage)
        this.$store.commit("gameStage", stage);
    }

}
